import { type ReactNode } from "react";
import { cn } from "@/shared/lib/utils";

interface ScreenCardProps {
  children: ReactNode;
  className?: string;
  /** Mono dossier line pinned between hairlines at the top of the card. */
  stage?: string;
}

/**
 * The dossier card every non-doors screen sits in: near-black panel,
 * gold hairline, deep shadow. Width is fluid — full-bleed minus gutters
 * on phones, capped at ~28rem on desktop.
 */
export function ScreenCard({ children, className, stage }: ScreenCardProps) {
  return (
    <div
      className={cn(
        "animate-rise-in mx-auto w-full max-w-md rounded-2xl border border-border",
        "bg-card/85 p-6 shadow-[0_26px_70px_rgba(0,0,0,0.6),inset_0_0_50px_rgba(0,0,0,0.4)]",
        "backdrop-blur-sm sm:p-8",
        className,
      )}
    >
      {stage && (
        <div className="mb-5 border-y border-border px-1 py-2 text-center font-mono text-[11px] leading-relaxed tracking-wide text-muted-foreground">
          {stage}
        </div>
      )}
      {children}
    </div>
  );
}
